/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import Footer from "examples/Footer";
import { Backdrop, Card, CardContent, CircularProgress, Grid, Typography } from "@mui/material";
import { useKardex } from "hooks/useKardex";
import KardexModulo from "components/VistaModulos/KardexModulo";
import { useKardexTabla } from "hooks/useKardexTabla";

function KardexTabla(): JSX.Element {
    const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || false);

    const {
        intl,
        procesando,
        isAlertOpen,
        mensajeAlert,
        handleisAlertClose,
        kardexPaginado,
        page,
        rowsPerPage,
        handleChangePage,
        handleChangeRowsPerPage,
        kardex,
        theme,
    } = useKardexTabla();

    return (
        <DashboardLayout>
            <MDBox py={2}>
                <Card>
                    <CardContent>
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                            sx={{ height: "100%", mt: 1 }}
                        >
                            <Typography variant="h4" gutterBottom>
                                Kardex Tabla
                            </Typography>
                        </Grid>
                        <Grid>
                            <KardexModulo
                                verKardex={kardex}
                                kardexPaginado={kardexPaginado}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                handleChangePage={handleChangePage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Grid>
                    </CardContent>
                </Card>
            </MDBox>

            {/*<Footer />*/}
            <Backdrop
                sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                open={procesando}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
                <Grid container spacing={2} style={{ textAlign: "center" }}>
                    <Grid item xs={12}>
                        <br />
                        <br />
                        <p>{mensajeAlert}</p>
                    </Grid>
                </Grid>
            </ModalComponent>
        </DashboardLayout>
    );
}

export default KardexTabla;
